import { Box, Tooltip } from "@mui/material";
import {DownloadIcon} from '../../../../../assets/icons/downloadIcon';
import {haveDisplay} from "../../HaveDisplayFunction"
import { useTranslation } from "react-i18next";
import SearchIcon from '@mui/icons-material/Search';
interface ILoupe {
    extension: string | undefined;
    onClickExibirViewer () : void;
    downloadFile () : void;
    itemType: string | undefined;
}

export default function Loupe({ 
    extension,
    onClickExibirViewer,
    downloadFile,
    itemType
}: ILoupe) {

    const { t } = useTranslation();

    const fileHasDisplay = haveDisplay(extension);

    return (
        <>
            {itemType === 'folder' ? (
                <Box
                    sx={{
                        opacity: .2
                    }}
                >
                    <SearchIcon sx={{ color: '#22638D' }}/>
                </Box>
            ) : (
                    <Tooltip title={fileHasDisplay  ? t('Visualizador.message') : 'Download'}>
                <Box
                    sx={{
                        cursor: "pointer",
                    }}
                    onClick={fileHasDisplay  ? onClickExibirViewer : downloadFile}
                >
                    {fileHasDisplay ? (
                        <SearchIcon sx={{ color: '#22638D' }} />
                    ) :
                        <DownloadIcon/>
                    }
                </Box>
                </Tooltip>
            )}
        </>
    )
}